
export default {
  // Custom: (app, config) => new Custom(app.bus, config),
}
